<template>
  <div class="duty-arrangement">
    <div class="duty-info-operation-container">
      <div class="duty-info-search-container">
        <!-- 搜索框 -->
        <search class="duty-search" placeholder="请输入编排名称" @search="dutySearch" />
        <!-- <el-date-picker
          class="date-select"
          v-model="dutyDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="dateChange"
        >
        </el-date-picker> -->
        <el-date-picker class="date-select" v-model="schoolYearVal" type="year" placeholder="学年"
          @change="schoolYearChangeHandle">
        </el-date-picker>
        <el-select class="date-select" v-model="semesterVal" placeholder="学期" clearable @change="semesterChangeHandle">
          <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </div>
      <div class="duty-operation-part-container">
        <!-- 新增 -->
        <button class="button add-duty" @click="addDutyShow = true" v-hasPermi="'sc:duty:add'">
          <i class="iconfont icon-addGlade"></i>新增编排
        </button>
      </div>
    </div>

    <!-- 列表栏容器 -->
    <div class="duty-info-table-container" v-bitmap="dutyListGetResult">
      <dutyList class="duty-list" :dutyList="dutyList" :semesterOptions="semesterOptions" v-show="total" />
    </div>
    <!-- 分页容器 -->
    <div class="duty-info-pagination-catainer">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange" @handleSizeChange="handleSizeChange" />
    </div>
    <!-- 新增编排弹窗 -->
    <addDutyDialog :addDutyShow.sync="addDutyShow" :semesterOptions="semesterOptions" v-show="addDutyShow" />
  </div>
</template>

<script>
import dutyList from "./components/duty-list/dutyList.vue";
import addDutyDialog from "./components/duty-add/duty-add.vue";
import search from "@/components/search/search.vue";
export default {
  components: {
    dutyList,
    addDutyDialog,
    search,
  },
  data() {
    return {
      // 值班日期
      dutyDate: "",
      // 值班名称
      dutyName: "",
      // 开始日期
      startDate: "",
      // 结束日期
      endDate: "",
      // 总数量
      total: 0,
      // 分页信息
      pageInfo: {
        // 每页显示的条数
        pageSize: 20,
        // 当前页数
        pageNum: 1,
      },
      // 值班列表
      dutyList: [],
      // 值班列表获取结果
      dutyListGetResult: "success",
      // 添加值班显示
      addDutyShow: false,
      schoolYearVal: "",
      semesterVal: "",
      semesterOptions: []
    };
  },
  created() {
    this.getDutyList();
    this.getDictType();
  },
  provide() {
    return {
      refresh: this.getDutyList,
    };
  },
  methods: {
    // 获取学期类型选择列表数据
    getDictType() {
      this.get(`${this.$url.getDictType}/semester_type`).then((res) => {
        // console.log("学期类型==>", res);
        this.semesterOptions = res.data;
      });
    },
    schoolYearChangeHandle(e) {
      // let schoolYear = e ? "" + e.getFullYear() : "";
      // console.log(e, schoolYear);
      this.getDutyList();
    },
    semesterChangeHandle(e) {
      // console.log(e, this.semesterVal);
      this.getDutyList();
    },
    dutySearch(e) {
      this.dutyName = e;
      this.getDutyList();
    },
    dateChange(e) {
      this.startDate = this.dutyDate ? this.dutyDate[0] : "";
      this.endDate = this.dutyDate ? this.dutyDate[1] : "";
      this.getDutyList();
    },
    getDutyList() {
      let data = {
        schoolId: this.user.schoolId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        dutyName: this.dutyName,
        startDate: this.startDate,
        endDate: this.endDate,
        schoolYear: this.schoolYearVal ? this.schoolYearVal.getFullYear() : "",
        semester: this.semesterVal
      };
      // this.checkListGetResult = "loading";
      this.get(this.$url.selectDutyList, data).then((res) => {
        // console.log("获取学校值日时间列表==>", res);
        if (res.code != 200) {
          this.dutyListGetResult = "error";
          return this.$message.error("获取值日时间失败");
        }
        this.dutyList = res.rows;
        this.total = res.total;
        this.total > 0
          ? (this.dutyListGetResult = "success")
          : (this.dutyListGetResult = "nullData");
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getDutyList();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getDutyList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./dutyArrangement.scss";
</style>
